import { Injectable, Injector } from '@angular/core';
import { Routes } from '@angular/router';
import { UiEngineComponent } from "../components/ui-engine/ui-engine.component";
import { RolePermissionService } from "../shared/services/role-permission.service";
@Injectable({
    providedIn: 'root'
})
export class CommonResolverService {
    public rolePermissionService: any;
    constructor(private injector: Injector) {
        this.rolePermissionService = injector.get(RolePermissionService);
    }
    getApplicationRoute(menuObj) {
        var routes: Routes = []
        var resources = this.rolePermissionService.parseMenuItemForPermission(menuObj);
        if (resources && resources.length) {
            resources.forEach((val, key) => {
                if (val.resource != undefined) {
                    if (val.auto_crud != undefined && val.auto_crud) {
                        var childRoutes : any = {
                            path: val.url,
                            data: {
                                breadcrumb: val.breadcrumb,
                                nav_url: (val.data != undefined && val.data.nav_url != undefined) ? val.data.nav_url : ''
                            },
                            children: [
                                {
                                    path: '',
                                    redirectTo: 'list',
                                    pathMatch: 'prefix'
                                },
                                {
                                    path: 'add',
                                    component: UiEngineComponent,
                                    data: {
                                        resource: val.resource,
                                        view: (val.view != undefined) ? val.view : '',
                                        action: 'ADD',
                                        decorator: val.resource,
                                        breadcrumb: 'Add',
                                        page_name: (val.page_name != undefined) ? val.page_name : '',
                                        form_data: (val.form_data != undefined) ? val.form_data : ''
                                    }
                                },
                                {
                                    path: ':id/modify',
                                    component: UiEngineComponent,
                                    data: {
                                        resource: val.resource,
                                        view: (val.view != undefined) ? val.view : '',
                                        action: 'MODIFY',
                                        breadcrumb: 'Edit',
                                        decorator: val.resource,
                                        page_name: (val.page_name != undefined) ? val.page_name : '',
                                        form_data: (val.form_data != undefined) ? val.form_data : ''
                                    }
                                },
                                {
                                    path: ':id/view',
                                    component: UiEngineComponent,
                                    data: {
                                        resource: val.resource,
                                        view: (val.view != undefined) ? val.view : '',
                                        action: 'VIEW',
                                        breadcrumb: 'View',
                                        page_name: (val.page_name != undefined) ? val.page_name : '',
                                        form_data: (val.form_data != undefined) ? val.form_data : ''
                                    }
                                },
                                {
                                    path: 'list',
                                    component: UiEngineComponent,
                                    data: {
                                        resource: val.resource,
                                        view: (val.view != undefined) ? val.view : '',
                                        action: 'LIST',
                                        breadcrumb: val.breadcrumb,
                                        page_name: (val.page_name != undefined) ? val.page_name : '',
                                        form_data: (val.form_data != undefined) ? val.form_data : ''
                                    }
                                }
                            ]
                        }

                        if (val.child != undefined && val.child.length > 0) {
                            for (let index = 0; index < val.child.length; index++) {
                                const child = val.child[index];
                                var childData = {
                                    parent_resource: val.resource,
                                    resource: child.resource,
                                    action: 'LIST',
                                    breadcrumb: 'View DETAILS',
                                    key: child.key,
                                    foreign_id: child.foreign_id,
                                    page_name: (child.page_name != undefined) ? child.page_name : '',
                                    form_data: (child.form_data != undefined) ? child.form_data : ''
                                }
                                var childRoute: any = {
                                    path: ':foreign_id/' + child.resource,
                                    component: UiEngineComponent,
                                    data: JSON.parse(JSON.stringify(childData))
                                }
                                childRoutes.children.push(childRoute);

                                childData.action = 'ADD';
                                var childRoute: any = {
                                    path: ':foreign_id/' + child.resource + '/ADD',
                                    component: UiEngineComponent,
                                    data: JSON.parse(JSON.stringify(childData))
                                }
                                childRoutes.children.push(childRoute);


                                childData.action = 'MODIFY';
                                var childRoute: any = {
                                    path: ':foreign_id/' + child.resource + '/:id/modify',
                                    component: UiEngineComponent,
                                    data: JSON.parse(JSON.stringify(childData))
                                }
                                childRoutes.children.push(childRoute);


                                childData.action = 'VIEW';
                                var childRoute: any = {
                                    path: ':foreign_id/' + child.resource + '/:id/view',
                                    component: UiEngineComponent,
                                    data: JSON.parse(JSON.stringify(childData))
                                }
                                childRoutes.children.push(childRoute);
                            }
                        }else if (val.route_def != undefined && val.route_def.dynamic != undefined) {
                            for (let index = 0; index < childRoutes.children.length; index++) {
                                let singleChildren = childRoutes.children[index];
                                if(singleChildren.path != ""){
                                    singleChildren.path += val.route_def.dynamic;
                                }
                                if(val.route_def.data != undefined){
                                    singleChildren.data = {...singleChildren.data,...val.route_def.data};
                                }
                            }

                        }
                        routes.push(childRoutes);
                    }
                } else if (val.children != undefined && val.children.length) {
                    var newRoute = this.getApplicationRoute(val.children);
                    if (newRoute.length) {
                        routes = routes.concat(newRoute);
                    }
                }
            });
        }
        return routes;
    }
}